import { storage } from '../../firestoreConfig';
import { ref, uploadString, getDownloadURL } from "firebase/storage";

class CommonCloudStorage {
    async uploadFromStringBase64(file, filename) {
        var storageRef = ref(storage, filename);
        var snapshot = await uploadString(storageRef, file, 'data_url').then((snapshot) => snapshot).catch(error => {
        });;
        var url = await getDownloadURL(snapshot.ref).then((downloadURL) => downloadURL);
        return url;
    };
}

export default new CommonCloudStorage();